
namespace Matrix.Dashboards {

    @Serenity.Decorators.registerClass()
    export class DatasetDialog extends SiteEntityDialog<DatasetRow, any> {
        protected getFormKey() { return DatasetForm.formKey; }
        protected getIdProperty() { return DatasetRow.idProperty; }
        protected getLocalTextPrefix() { return DatasetRow.localTextPrefix; }
        protected getNameProperty() { return DatasetRow.nameProperty; }
        protected getService() { return DatasetService.baseUrl; }
        protected getDeletePermission() { return DatasetRow.deletePermission; }
        protected getInsertPermission() { return DatasetRow.insertPermission; }
        protected getUpdatePermission() { return DatasetRow.updatePermission; }

        protected form = new DatasetForm(this.idPrefix);

        private dataSourceProps: Serenity.PropertyGrid;

        constructor() {
            super();

            this.initDataSourceProps();

            this.form.DatasetType.change(e => this.initDataSourceProps());
            this.form.ParameterList.updateParameters = () => this.updateParameters(true, true);
        }

        protected useViewMode() {
            return false;
        }

        public loadEntity(entity: DatasetRow) {
            super.loadEntity(entity);
            this.initDataSourceProps(entity.Properties);
            this.form.ParameterList.value = entity.Properties?.ParameterList || [];
        }

        protected getSaveEntity(): DatasetRow {
            var e = super.getSaveEntity();
            e.Properties = this.dataSourceProps.save();
            e.Properties.ParameterList = this.form.ParameterList.value || [];
            delete (e as any).ParameterList;
            return e;
        }

        private initDataSourceProps(value?: any) {

            var el: JQuery;
            if (this.dataSourceProps) {
                el = this.dataSourceProps.element;
                this.dataSourceProps.destroy();
                this.dataSourceProps = null;
                el.html('');
            }
            else
                el = $('<div/>').insertAfter(this.propertyGrid.element);

            this.form.ParameterList.value = [];
            this.form.DatasetType.getGridField().parent().children('.ds-prop-field').remove();

            var items: Serenity.PropertyItem[];
            var useParameters = false;
            var dataSourceType = this.form.DatasetType.value;
            if (dataSourceType) {
                var dataSourceTypeItem = Q.getLookup<DataSourceTypeItem>("Dashboards.DataSourceType")
                    .itemById[dataSourceType];
                if (dataSourceTypeItem) {
                    items = dataSourceTypeItem.Options;
                    useParameters = dataSourceTypeItem.UseParameters;
                }
            }

            items = items || [];

            this.dataSourceProps = new Serenity.PropertyGrid(el, {
                items: items,
                mode: Serenity.PropertyGridMode.insert,
                idPrefix: this.idPrefix + "DSProps_"
            });

            this.dataSourceProps.element.find('div.field')
                .addClass('ds-prop-field')
                .insertAfter(this.form.DatasetType.getGridField());

            this.dataSourceProps.load(value || {});

            this.form.ParameterList.getGridField().toggle(!!useParameters);

            this.dataSourceProps.get_editors().forEach((widget: any) => {
                if (Q.isAssignableFrom(Serenity.Select2Editor, Q.getInstanceType(widget)))
                    widget.changeSelect2(() => this.updateParameters(true, false));
                else if (Q.isAssignableFrom(CodeEditor, Q.getInstanceType(widget))) {
                    var bindToCodeEditor = () => {
                        widget["editor"]?.on('focus', () => { widget.__oldValue = widget.get_value(); });
                        widget["editor"]?.on('blur', () => {
                            if (widget.__oldValue != widget.get_value()) {
                                this.updateParameters(true, false);
                            }
                        });
                    };

                    if (widget["editor"])
                        bindToCodeEditor();
                    else
                        widget.element.one('editorinit', bindToCodeEditor);
                }
                else
                    widget.change(() => this.updateParameters(true, false));
            });
        }

        getEditor<TWidget = Serenity.Widget<any>>(property: string, widgetType: { new(...args: any[]): TWidget; }): TWidget {
            return this.byId("DSProps_" + property).getWidget<TWidget>(widgetType);
        }

        updateParameters(merge, manuallyTriggered: boolean) {

            if (!this.form.DatasetType.value || !this.validateForm()) {
                return;
            }

            DatasetService.ExtractParameters({
                DataSourceType: this.form.DatasetType.value,
                Properties: (this.dataSourceProps?.save() || {})
            }, response => {
                if (!merge) {
                    this.form.ParameterList.value = response.Parameters || [];
                    return;
                }

                var oldByName: Q.Dictionary<Data.DataParameter> = {};
                for (var k of (this.form.ParameterList.value || []))
                    oldByName[k.Name] = k;

                this.form.ParameterList.value = (response.Parameters || []).map(x => {
                    var old = oldByName[x.Name];
                    if (old) {
                        old.Type = x.Type;
                        old.Size = x.Size;
                        old.Scale = x.Scale;
                        return old;
                    }
                    return x;
                });
            }, {
                async: false,
                blockUI: false,
                onError: (response: Serenity.ServiceResponse) => {
                    if (response?.Error?.Message && !manuallyTriggered)
                        Q.notifyError(response.Error.Message);
                    else
                        Q.ErrorHandling.showServiceError(response.Error);
                }
            });
        }
    }
}